// Phase 7 D3 — Track C T-C2. /settings/account page.
//
// Three sections:
//   1. Email — read-only. The backend does not currently support email
//      change; copy explicitly says so.
//   2. Change password — ChangePasswordForm component.
//   3. Delete account — DeleteAccountDialog (Q-3b: phrase + password gate).

import * as React from 'react';
import { copy } from '@dailydeck/shared/copy';
import { useAuth } from '../../../hooks/useAuth.js';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/Card.js';
import { ChangePasswordForm } from './ChangePasswordForm.js';
import { DeleteAccountDialog } from './DeleteAccountDialog.js';

export function Account(): JSX.Element {
  React.useEffect(() => {
    document.title = `DailyDeck — ${copy.settings.shell.nav.account}`;
  }, []);

  const { user } = useAuth();

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h2
          id="settings-section-heading"
          className="text-title-2 font-semibold text-text-primary"
        >
          {copy.settings.account.title}
        </h2>
        <p className="text-body text-text-secondary mt-1">
          {copy.settings.account.description}
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>{copy.settings.account.emailLabel}</CardTitle>
          <CardDescription>{copy.settings.account.emailHelp}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-1.5">
            <label
              htmlFor="settings-account-email"
              className="text-body-strong text-text-primary sr-only"
            >
              {copy.settings.account.emailLabel}
            </label>
            <input
              id="settings-account-email"
              type="email"
              readOnly
              value={user?.email ?? ''}
              aria-readonly="true"
              className="flex h-10 w-full rounded-md border border-border-default bg-surface-base px-3 py-2 text-body text-text-secondary"
            />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{copy.settings.account.changePasswordTitle}</CardTitle>
          <CardDescription>
            {copy.settings.account.changePasswordDescription}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ChangePasswordForm />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{copy.settings.account.deleteAccountTitle}</CardTitle>
          <CardDescription>
            {copy.settings.account.deleteAccountDescription}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <DeleteAccountDialog />
        </CardContent>
      </Card>
    </div>
  );
}
